exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".video-list {\n  width: 100%;\n  margin-top: -2em;\n  margin-bottom: 2em;\n}\n\n.video-holder {\n  float: right;\n  margin: 0 1em 1em 0;\n}\n", ""]);

